module.exports = __webpack_public_path__ + "static/media/related-pro-img2.de1fd59d.jpg";